import { render, staticRenderFns } from "./m-addStatementAnswer.vue?vue&type=template&id=231c369d&"
import script from "./m-addStatementAnswer.vue?vue&type=script&lang=js&"
export * from "./m-addStatementAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports